export const sources={};export const img={src:"__VITE_ASSET__UF4iDpNJhIbRdkaNqmNRqw__",w:640,h:640};export default{sources:sources,img:img};